export default __webpack_public_path__ + "static/media/compliance.124e1db2.png";